const DEFAULT_BASE_URL = 'https://app.chatwoot.com';

const WIDGET_SETTINGS = {
  hideMessageBubble: true,
  position: 'left',
  type: 'standard',
  launcherTitle: 'Chat with us',
};

const isLocalHost = (hostname) => ['localhost', '127.0.0.1'].includes(hostname);

// Loads the Chatwoot SDK for the per-environment website token (VITE_CHATWOOT_WEBSITE_TOKEN).
// An empty token (dev until a dev inbox exists) or a local host loads nothing, so test chats
// never reach another environment's inbox. HeaderSupportChat reads window.chatwootLoadFailed to
// show "unavailable" instead of waiting for a widget that will never come.
export function setupChatwoot({
  token = import.meta.env.VITE_CHATWOOT_WEBSITE_TOKEN,
  baseUrl = import.meta.env.VITE_CHATWOOT_BASE_URL || DEFAULT_BASE_URL,
  win = window,
  doc = document,
} = {}) {
  const websiteToken = typeof token === 'string' ? token.trim() : '';
  if (!websiteToken || isLocalHost(win.location.hostname)) {
    win.chatwootLoadFailed = true;
    return false;
  }

  win.chatwootSettings = { ...WIDGET_SETTINGS };

  const script = doc.createElement('script');
  script.src = `${baseUrl}/packs/js/sdk.js`;
  script.async = true;
  script.onerror = () => {
    win.chatwootLoadFailed = true;
    win.dispatchEvent(new Event('chatwoot:error'));
    console.warn('Chatwoot failed to load');
  };
  script.onload = () => {
    win.chatwootSDK.run({ websiteToken, baseUrl });
  };
  doc.head.appendChild(script);
  return true;
}
